import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import PendingIcon from '@mui/icons-material/Pending';
import Typography from '@mui/material/Typography';
import { CSSProperties } from 'react';

export type OnHoldReasonType = 'Payment Declined' | 'Manual';

interface OnHoldReasonBadgeProps {
  reason: OnHoldReasonType | null | undefined;
}

const commonStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: '0.1875rem',
  alignItems: 'center',
  padding: '0.1875rem 0.625rem',
  justifyContent: 'center',
  borderRadius: '1.25rem',
  border: 'none',
};

const reasonConfig: Record<OnHoldReasonType, { background: string; IconComponent: any; color: string }> = {
  'Payment Declined': {
    background: '#ffe8e7',
    IconComponent: ReportProblemIcon,
    color: '#5E0A05',
  },
  Manual: {
    background: '#ffeedf',
    IconComponent: PendingIcon,
    color: '#7B3F07',
  },
};

const OnHoldReasonBadge = ({ reason }: OnHoldReasonBadgeProps) => {
  if (!reason) return null;

  const config = reasonConfig[reason];
  if (!config) return null;

  const { background, IconComponent, color } = config;

  return (
    <div style={{ ...commonStyle, background }}>
      <IconComponent sx={{ fontSize: '0.875rem', color }} />
      <Typography sx={{ fontSize: '0.875rem', color }}>{reason}</Typography>
    </div>
  );
};

export default OnHoldReasonBadge;
